import { IEmailTemplate } from 'modules/_common/models';
import API from 'services/api';

export const getInvoiceEmails = (invoiceId: string): Promise<IEmailTemplate> =>
  API.get(`/api/documents/invoices/${invoiceId}/email`).then(response => response?.data);
